import WixSDK from 'shared/utils/wix-sdk';
import { createAction } from 'redux-actions';


export const LOGIN_NAME = 'CLIENT.LOGIN.FROM-MOBILE-WIDGET';
const LOGIN_ACTION = createAction(LOGIN_NAME);


export function login() {
  return function (dispatch) {
    dispatch(LOGIN_ACTION());

    return WixSDK.requestLogin();
  };
}



// WEBPACK FOOTER //
// ./src/widget/redux/client/actions/login-from-mobile-widget.js